import axios from "axios";

const marketplace_id = 1

export default class WebApiCalls {
  // HOST_NAME
  HOST_NAME = `${process.env.REACT_APP_TOKRI_API_URL}/api`;

  //END POINTS
  PRODUCT_SYNC = "importmerchantproducts"
  // Register
  _REGISTER = '/register'

  // LOGIN
  _LOGIN = '/login'


  async sendRequest(url, request) {
    try {
      let response = await fetch(url, request);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      let err = [];
      err.error = error;
      err.no_result = true;
      return err;
    }
  }
  async sendPostRequest(_url, _params, custom_headers) {
    _url = this.HOST_NAME + _url;
    // if (_url.indexOf('?') >= 0) {
    //     _url = _url + '&' + 'ts=' + Date.now().toString();
    // } else {
    //     _url = _url + '?' + 'ts=' + Date.now().toString();
    // }
    let _headers = custom_headers;
    if (!_headers) {
      _headers = [];
    }
    // _headers["Content-Type"] = "application/json";
    if (!_params) {
      _params = {}
    }
    try {
      let response = await axios({
        method: 'post',
        url: _url,
        body: _params,
        headers: _headers,
        redirect: 'follow'
      });
      return response;
    } catch (error) {
      let err = [];
      err.error = error;
      err.no_result = true;
      console.log("catch error on ", _url, " call fail", err)
      setTimeout(() => {
      }, 400)
      return err;
    }
  }

  registerUser(tokenObj) {
    let url = `${this._REGISTER}`;
    // new formData = new FormData();
    console.log("URL...", url)
    let request = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: tokenObj.authentication,
      },
    };
    return this.sendRequest(url, request);
  }

  loginUser(tokenObj) {
    let url = `${this._LOGIN}`;
    let body = tokenObj;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    // let headers = {
    //     "Content-Type": "application/x-www-form-urlencoded",  
    // };
    // return this.sendPostRequest(url, body, myHeaders)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: tokenObj,
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/login`, requestOptions)
      .then(response => response.text())
      .then(result => { return result })
      .catch(error => console.log('error', error));
  }

  getProductSync = (token) => {
    let url = `${this.HOST_NAME}/${this.PRODUCT_SYNC}/`
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token)
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
    };
    return this.sendRequest(url, requestOptions)
  }
}



